<template>
  <div>
    <section class="banner">
      <v-layout column align-center justify-center class="banner-bottom">
        <div class="familiacantu white--text text-xs-center">Família Cantu</div>
        <div class="brasil white--text text-xs-center">NO BRASIL</div>
        <img src="/static/img/Ativo 10@4x.png" alt="FAMILIA CANTU" width="400" height="25">
      </v-layout>
    </section>

    <section class="banner3">
      <v-layout
        column
        wrap
        class="mt-5 ml-5 mr-5"
        align-center
      >
        <v-flex xs12 sm4 class="mt-3 ml-3 mr-3">
          <v-layout column align-center justify-center>
            <div class="historia text-xs-center">ÁRVORE GENEALÓGICA</div>
            <hr class="historiahr">
          </v-layout>
        </v-flex>
        
      </v-layout>
      <v-layout column align-center justify-center class="img-arvore mt-5">
        <v-layout wrap align-center>
          <v-flex xs12 sm12 >
            <v-card-text class="text-xs-center brasil1">Conheça a Árvore genealógica<br>da família Cantu no Brasil</v-card-text>
          </v-flex>
        </v-layout>
        <v-btn class="vejamais" href="/static/pdf/Arvore Genealógica Família Cantú.pdf" download>Acesse</v-btn>
      </v-layout>
    </section>
  </div>
</template>

<script>
import store from "../store";

export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Hello ' + this.$store.state.world,
      server: this.$store.getters.server,
      model: {name: "", endereco: "", telefone: "", descricao: "", desconto: 0},
      descontos: [],
      message: "",
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
    }
  },
  created () {
    
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .img-arvore {
    background-image: url('/static/img/Ativo 18@4x.png');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 850px;
    max-height: 100%;
    height: 320px;
    min-height: 260px;
    width: 100%;
    padding-top: 40px;
    margin-bottom: 100px;
    position:relative; 
  }
  .banner {
    background-image: url('/static/img/Ativo 14@4x.png');
    background-repeat: no-repeat;
    background-position: left top;
    background-size: 100% 850px;
    max-height: 100%;
    height: 260px;
    min-height: 260px;
    width: 100%;
    padding-top: 100px;
    position:relative; 
  }
  .brasil {
    font-size: 30px;
    color: white;
    text-align: center;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .brasil1 {
    font-size: 3vw;
    margin-top: 40px !important;
    color: white;
    text-align: center;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .historia {
    height: 20px + 2vw;
    font-size: 50px;
    color: #a56d30;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
  }
  .historiahr {
    width: 200px;
    border: 0; border-top: 1px solid #a56d30;
  }
  .familiacantu {
    height: 60px;
    widows: 220px;
    font-size: 60px;
    font-family: 'marguerite', sans-serif !important;
  }

  .vejamais {
    background-color: #c99d66 !important;
    color: white;
    height: 30px;
    border-radius: 20%;
    text-transform: none;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
    padding: 20px 60px 20px 60px;
    margin-bottom: 100px;
    margin-left: auto;
    margin-right: auto;
  }
  .tree ul {
    padding-top: 20px; position: relative;
    
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
  }

  .tree li {
    float: left; text-align: center;
    list-style-type: none;
    position: relative;
    padding: 20px 5px 0 5px;
    
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
  }

  /*We will use ::before and ::after to draw the connectors*/

  .tree li::before, .tree li::after{
    content: '';
    position: absolute; top: 0; right: 50%;
    border-top: 1px solid #ccc;
    width: 50%; height: 20px;
  }
  .tree li::after{
    right: auto; left: 50%;
    border-left: 1px solid #ccc;
  }

  /*We need to remove left-right connectors from elements without 
  any siblings*/
  .tree li:only-child::after, .tree li:only-child::before {
    display: none;
  }

  /*Remove space from the top of single children*/
  .tree li:only-child{ padding-top: 0;}

  /*Remove left connector from first child and 
  right connector from last child*/
  .tree li:first-child::before, .tree li:last-child::after{
    border: 0 none;
  }
  /*Adding back the vertical connector to the last nodes*/
  .tree li:last-child::before{
    border-right: 1px solid #ccc;
    border-radius: 0 5px 0 0;
    -webkit-border-radius: 0 5px 0 0;
    -moz-border-radius: 0 5px 0 0;
  }
  .tree li:first-child::after{
    border-radius: 5px 0 0 0;
    -webkit-border-radius: 5px 0 0 0;
    -moz-border-radius: 5px 0 0 0;
  }

  /*Time to add downward connectors from parents*/
  .tree ul ul::before{
    content: '';
    position: absolute; top: 0; left: 50%;
    border-left: 1px solid #ccc;
    width: 0; height: 20px;
  }

  .tree li a{
    border: 1px solid #ccc;
    padding: 5px 10px;
    text-decoration: none;
    color: #666;
    font-size: 8px;
    width: 70px;
    font-family: 'TrajanPro3-Regular', sans-serif !important;
    display: inline-block;
    
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    
    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
  }

  /*Time for some hover effects*/
  /*We will apply the hover effect the the lineage of the element also*/
  .tree li a:hover, .tree li a:hover+ul li a {
    background: #c8e4f8; color: #000; border: 1px solid #94a0b4;
  }
  /*Connector styles on hover*/
  .tree li a:hover+ul li::after, 
  .tree li a:hover+ul li::before, 
  .tree li a:hover+ul::before, 
  .tree li a:hover+ul ul::before{
    border-color:  #94a0b4;
  }
</style>
<!--div class="tree">
                  <ul>
                    <li class="mt-5">
                      <a href="#">Lúcia Cantú</a>
                      <a href="#">Beniamino Giovanni Baseggio</a>
                      <ul>
                        <li>
                          <a href="#">Amália Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Marieta Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Alberto Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Ricardo Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Laurindo Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Primo Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Albina Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Angelo Baseggio</a>
                        </li>
                        <li>
                          <a href="#">João Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Albino Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Estevão Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Ernesto Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Teresa Baseggio</a>
                        </li>
                        <li>
                          <a href="#">Letícia Baseggio</a>
                        </li>
                      </ul>
                        
                    </li>
                  </ul>
                </div>
                <div class="tree">
                  <ul>
                    <li class="mt-5">
                      <a href="#">Pietro Silvio Cantú</a>
                      <a href="#">Santa Barbieri</a>
                      <ul>
                        <li>
                          <a href="#">Ricieri José Cantú</a>
                          <a href="#">Barbara Baioco</a>
                        </li>
                        <li>
                          <a href="#">Maria Cantú</a>
                          <a href="#">Angelo Locatelli</a>
                        </li>
                        <li>
                          <a href="#">Guilherme Cantú</a>
                          <a href="#">Maria Salvi</a>
                        </li>
                        <li>
                          <a href="#">Domingos Cantú</a>
                          <a href="#">Carolina Salvi</a>
                        </li>
                        <li>
                          <a href="#">Victório Cantú</a>
                        </li>
                        <li>
                          <a href="#">Vergílio Domingos Cantú</a>
                          <a href="#">Melânia Defendi</a>
                        </li>
                        <li>
                          <a href="#">Palmira Cantú</a>
                          <a href="#">Luiz Salvi</a>
                        </li>
                        <li>
                          <a href="#">Valéria Maghia Cantú</a>
                          <a href="#">Augusto Mariani</a>
                        </li>
                        <li>
                          <a href="#">Francisco Cantú</a>
                          <a href="#">Davidica Pellazzani</a>
                        </li>
                        <li>
                          <a href="#">Cezare Cantú</a>
                          <a href="#">Santina Pavan</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div class="tree">
                  <ul>
                    <li class="mt-5">
                      <a href="#">Giovanni Maria Cantú</a>
                      <a href="#">Santa Ferranti</a>
                      <ul>
                        <li>
                          <a href="#">José Vergílio Cantú</a>
                          <a href="#">Ana Maria Rigo</a>
                          <a href="#">Dileta Morelato</a>
                        </li>
                        <li>
                          <a href="#">Amante Cantú</a>
                          <a href="#">Graciosa Noelo</a>
                        </li>
                        <li>
                          <a href="#">Cezare Cantú</a>
                        </li>
                        <li>
                          <a href="#">João Domingos Cantú</a>
                          <a href="#">Clélia Barichello</a>
                        </li>
                        <li>
                          <a href="#">Valentim Cantú</a>
                          <a href="#">Filomena Dal Pizzol</a>
                        </li>
                        <li>
                          <a href="#">Linda Cantú</a>
                          <a href="#">Isidoro Mamentini</a>
                        </li>
                        <li>
                          <a href="#">Luiz Cantú</a>
                          <a href="#">Maria Reck</a>
                          <a href="#">Helena Biscaro</a>
                        </li>
                        <li>
                          <a href="#">Valéria Cantú</a>
                        </li>
                        <li>
                          <a href="#">Angelina Cantú</a>
                          <a href="#">Carlos DallAgnol</a>
                        </li>
                        <li>
                          <a href="#">Marieta Cantú</a>
                          <a href="#">Vitório Guarda</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div-->


// WEBPACK FOOTER //
// src/pages/Arvore.vue